export default {
    iconList:[
    "ff_icon_yinle",
    "ff_icon_lvxing",
    "ff_icon_wangyou",
    "ff_icon_huafei",
    "ff_icon_yangshengqi",
    "ff_icon_yinle1",
    "ff_icon_yundong",
    "ff_icon_cuowu",
    "ff_icon_jinzhi",
    "ff_icon_tixing",
    "ff_icon_tishi1",
    "ff_icon_jinggao",
    "ff_icon_wangluo",
    "ff_icon_chuangyi",
    "ff_icon_jianqie",
    "ff_icon_suoding",
    "ff_icon_shuzhuangtu",
    "ff_icon_quxiantu",
    "ff_icon_zhexiantu",
    "ff_icon_shejishi",
    "ff_icon_jingjia",
    "ff_icon_guanggaowei",
    "ff_icon_tianjiaguanggaowei",
    "ff_icon_michi",
    "ff_icon_paixu",
    "ff_icon_xiangzuo",
    "ff_icon_xiangshang",
    "ff_icon_xiangyou",
    "ff_icon_biaoqian",
    "ff_icon_shanshuo",
    "ff_icon_yunxiazai",
    "ff_icon_chijing",
    "ff_icon_dai",
    "ff_icon_ganga",
    "ff_icon_facebook",
    "ff_icon_shouye1",
    "ff_icon_yonghu1",
    "ff_icon_wenben",
    "ff_icon_baocun",
    "ff_icon_duihua",
    "ff_icon_tupian",
    "ff_icon_chexiao1",
    "ff_icon_zhongzuo",
    "ff_icon_shanchu1",
    "ff_icon_qita",
    "ff_icon_xinxi1",
    "ff_icon_bangzhu",
    "ff_icon_shoucang",
    "ff_icon_xiai",
    "ff_icon_weizhi",
    "ff_icon_jian",
    "ff_icon_jia",
    "ff_icon_cuowu1",
    "ff_icon_zhengque",
    "ff_icon_fujian",
    "ff_icon_shuaxin1",
    "ff_icon_dantupailie",
    "ff_icon_shipin",
    "ff_icon_xiangshang6",
    "ff_icon_xiangxia",
    "ff_icon_jia1",
    "ff_icon_gouwucheman",
    "ff_icon_gouwuchekong",
    "ff_icon_tuichu",
    "ff_icon_suoding1",
    "ff_icon_luyin",
    "ff_icon_jinru",
    "ff_icon_zhuanwan",
    "ff_icon_gaosu",
    "ff_icon_jiesuo",
    "ff_icon_tuige",
    "ff_icon_zuoshang",
    "ff_icon_xiangshang7",
    "ff_icon_youshang",
    "ff_icon_xiangxia6",
    "ff_icon_youxia",
    "ff_icon_xiangzuo3",
    "ff_icon_suoxiao",
    "ff_icon_fangda",
    "ff_icon_quanping",
    "ff_icon_suoxiao1",
    "ff_icon_fangda1",
    "ff_icon_xinhao",
    "ff_icon_tongzhi1",
    "ff_icon_dingwei",
    "ff_icon_O",
    "ff_icon_paixu1",
    "ff_icon_xiangxia7",
    "ff_icon_xiangshang8",
    "ff_icon_paixu2",
    "ff_icon_xinrenzhinan",
    "ff_icon_danxuanfill",
    "ff_icon_danxuan",
    "ff_icon_fangxingweixuanzhong",
    "ff_icon_fangxingxuanzhongfill",
    "ff_icon_fangxingxuanzhong",
    "ff_icon_guanbi1",
    "ff_icon_guanbi2fill",
    "ff_icon_guanbi2",
    "ff_icon_jiahao",
    "ff_icon_jiahao1",
    "ff_icon_jiahao2fill",
    "ff_icon_jianhao",
    "ff_icon_tishifill",
    "ff_icon_tishi",
    "ff_icon_wenhaofill",
    "ff_icon_wenhao",
    "ff_icon_xuanze",
    "ff_icon_yuanxingweixuanzhong",
    "ff_icon_yuanxingxuanzhongfill",
    "ff_icon_yuanxingxuanzhong",
    "ff_icon_biaoxingfill",
    "ff_icon_biaoxing",
    "ff_icon_chexiao",
    "ff_icon_dianpufill",
    "ff_icon_dianpu",
    "ff_icon_dingdan",
    "ff_icon_fankui",
    "ff_icon_fenxiang",
    "ff_icon_gengduo",
    "ff_icon_gonglve",
    "ff_icon_gouwuchefill",
    "ff_icon_gouwuche",
    "ff_icon_gouwudai",
    "ff_icon_qiapianxingshi",
    "ff_icon_kefufill",
    "ff_icon_kefu",
    "ff_icon_liebiaoxingshi",
    "ff_icon_liuyanfill",
    "ff_icon_liuyan",
    "ff_icon_pengyoufill",
    "ff_icon_pengyou",
    "ff_icon_qingchu",
    "ff_icon_quan",
    "ff_icon_saoma",
    "ff_icon_shaixuan",
    "ff_icon_shanchu",
    "ff_icon_shezhi",
    "ff_icon_shenfen",
    "ff_icon_shizhongfill",
    "ff_icon_shizhong",
    "ff_icon_shouyefill",
    "ff_icon_shouye",
    "ff_icon_sousuo",
    "ff_icon_sousuoleimufill",
    "ff_icon_sousuoleimu",
    "ff_icon_taojinbi",
    "ff_icon_tianmao",
    "ff_icon_tongzhifill",
    "ff_icon_tongzhi",
    "ff_icon_tuikuan",
    "ff_icon_wodefill",
    "ff_icon_wode",
    "ff_icon_wuliu",
    "ff_icon_xihuanfill",
    "ff_icon_xihuan",
    "ff_icon_xinxifill",
    "ff_icon_xinxi",
    "ff_icon_youhuiquan",
    "ff_icon_yuyan",
    "ff_icon_zhengli",
    "ff_icon_zuji",
    "ff_icon_zuobiaofill",
    "ff_icon_zuobiao",
    "ff_icon_dibu",
    "ff_icon_dingbujinzhi",
    "ff_icon_dingbu",
    "ff_icon_xiangshang1",
    "ff_icon_xiangshang2",
    "ff_icon_xiangshang3",
    "ff_icon_xiangshang5",
    "ff_icon_xiangxia1",
    "ff_icon_xiangxia2",
    "ff_icon_xiangxia3",
    "ff_icon_xiangxia5",
    "ff_icon_xiangyou1",
    "ff_icon_xiangyou2",
    "ff_icon_xiangyou3fill",
    "ff_icon_xiangyou3",
    "ff_icon_xiangzuo1",
    "ff_icon_xiangzuo2",
    "ff_icon_xiangji1fill",
    "ff_icon_xiangji1",
    "ff_icon_xiangji2",
    "ff_icon_jiazai",
    "ff_icon_shuaxin",
    "ff_icon_wifi",
    "ff_icon_hongbao",
    "ff_icon_xinyongqia",
    "ff_icon_shoujitaobao",
    "ff_icon_yonghufill",
    "ff_icon_yonghu",
    "ff_icon_juhuasuan",
    "ff_icon_salefill",
    "ff_icon_sale",
    "ff_icon_zengsong",
    "ff_icon_androidgengduo",
    "ff_icon_leimu",
    "ff_icon_bangzhuzhongxin",
    "ff_icon_caidan",
    "ff_icon_zantongfill",
    "ff_icon_zantong",
    "ff_icon_xiangshang4",
    "ff_icon_xiangxia4",
    "ff_icon_dianhua",
    "ff_icon_danpin",
    "ff_icon_duozhongzhifu",
    "ff_icon_erweima",
    "ff_icon_guojiwuliu",
    "ff_icon_huwai",
    "ff_icon_jujia",
    "ff_icon_kuzi",
    "ff_icon_muying",
    "ff_icon_nanzhuang",
    "ff_icon_neiyi",
    "ff_icon_nvzhuang",
    "ff_icon_pinpai",
    "ff_icon_tequanzhuanshu",
    "ff_icon_xiangbao",
    "ff_icon_yishouchu",
    "ff_icon_others",
    "ff_icon_hrstaff",
    "ff_icon_Nav01-home",
    "ff_icon_Nav03-base",
    "ff_icon_Nav04-customer",
    "ff_icon_Nav05-sale",
    "ff_icon_Nav06-goods",
    "ff_icon_Nav07-reports",
    "ff_icon_Nav08-marketing",
    "ff_icon_base_itemxiangmuguanli",
    "ff_icon_base_goodchanpinguanli",
    "ff_icon_base_dictionaryshujuzidian",
    "ff_icon_base_globalParamsquanjucanshu",
    "ff_icon_duanxintongdaobaohu",
    "ff_icon_gongyingshang",
    "ff_icon_basesettingcompany",
    "ff_icon_basesettingdepartment",
    "ff_icon_basesettingposition",
    "ff_icon_basesettingwarehouse",
    "ff_icon_basesettingwarehouseShop",
    "ff_icon_basesettingcustomerPortrait",
    "ff_icon_basesettingCityCate",
    "ff_icon_gonggao",
    "ff_icon_basesettingnoticeManage",
    "ff_icon_basesalescardPackage",
    "ff_icon_basesalescouponManage",
    "ff_icon_basesalescouponSendList",
    "ff_icon_basesalessendSet",
    "ff_icon_basesalesintegralSet",
    "ff_icon_basesalesintegralSpecial",
    "ff_icon_basesalesupstarSet",
    "ff_icon_basesalesupstarCustomer",
    "ff_icon_basesalesupstarSendSet",
    "ff_icon_basesalesupgradeSet",
    "ff_icon_basepermissionauthGroup",
    "ff_icon_basepermissionauthMenu",
    "ff_icon_basepermissionauthShop",
    "ff_icon_basepermissionapproveProcess",
    "ff_icon_basepermissionapproveApply",
    "ff_icon_basepermissionapproveList",
    "ff_icon_basepermissionapproveCc",
    "ff_icon_basepermissionapproveTempSend",
    "ff_icon_basesystemlogger",
    "ff_icon_hrstaffarchives",
    "ff_icon_hrstaffdimission",
    "ff_icon_hrattendanceschedule",
    "ff_icon_hrattendancescheduleSet",
    "ff_icon_hrattendanceconfirm",
    "ff_icon_hrattendancevacation",
    "ff_icon_hrattendanceleave",
    "ff_icon_hrwelfarestaffSaleSend",
    "ff_icon_hrwelfarestaffConsumeSend",
    "ff_icon_hrwelfarestaffSendRecord",
    "ff_icon_hrcollegepeopleCardingRange",
    "ff_icon_hrcollegestoreYearTarget",
    "ff_icon_hrcollegestaffCollegePlan",
    "ff_icon_hrcollegestaffCollege",
    "ff_icon_hrsalarypunishment",
    "ff_icon_hrsalarypunishmentType",
    "ff_icon_customerarchivescustomer",
    "ff_icon_customerarchivestransfer",
    "ff_icon_customerarchivesreissue",
    "ff_icon_customerarchivesspecial",
    "ff_icon_customerarchivesrecycleBin",
    "ff_icon_saleordersaleOrder",
    "ff_icon_saleordersaleDetail",
    "ff_icon_saleordersaleDraft",
    "ff_icon_saleordertempSend",
    "ff_icon_saleorderposList",
    "ff_icon_saleorderreturnManage",
    "ff_icon_saleorderdepositManage",
    "ff_icon_saleordersendDetail",
    "ff_icon_salebookingmanage",
    "ff_icon_salecashTransfertransferList",
    "ff_icon_salecashTransfertransferDetail",
    "ff_icon_saleconsumeconsumeDetail",
    "ff_icon_saleconsumeconsumeList",
    "ff_icon_goodswhinStock",
    "ff_icon_goodswhoutStock",
    "ff_icon_goodswhsupply",
    "ff_icon_goodswhbackorder",
    "ff_icon_goodswhinventory",
    "ff_icon_goodswhoutStockIndex",
    "ff_icon_goodswhDetail",
    "ff_icon_goodswhtotalStock",
    "ff_icon_goodsppesupplier",
    "ff_icon_goodsppearchivesManage",
    "ff_icon_goodsppearchivesHandle",
    "ff_icon_goodsppetaskManage",
    "ff_icon_goodsppecategory",
    "ff_icon_goodsppeinventory",
    "ff_icon_goodsppearchivesIndex",
    "ff_icon_marketingturntablelottery",
    "ff_icon_marketingturntableactivityManage",
    "ff_icon_marketingturntablewinningDetail"
]}
